import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const DashboardContainer = styled.div`
  .container-fluid {
    padding-right: 0;
    padding-left: 0;

    .dashboard-wrapper {
      margin: 0 auto;
      .dashboard-header {
        background-color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  .dashboard-body {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 132px);

    .dashboard-content {
      width: 100%;
      overflow-y: auto;
    }

    @media (min-width: ${breakpoints.desktop}px) {
      flex-direction: row;
      margin-top: 1rem;
      margin-bottom: 1rem;
      min-height: 500px;
      height: calc(100vh - 207px);
      overflow-y: auto;

      .dashboard-content {
        padding-right: 1rem;
      }

      @media (min-height: 1100px) {
        height: 950px;
        max-height: 950px;
      }
      @media (min-height: 1200px) {
        height: 1050px;
        max-height: 1050px;
      }
    }
    }
  }

  @media (max-width: ${breakpoints.sm}px) {
    .container-fluid {
      padding: 0;
      .dashboard-wrapper {
        .dashboard-header {
          flex-direction: column-reverse;
        }
      }
    }
    .nav-tabs {
      border-bottom: 1px solid white;
      a {
        color: #495057;
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }

  @media (min-width: 901px) {
    .dashboard-header {
      margin-top: 0 !important;
      padding-left: 2rem !important;
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
    .topbar-top {
      margin-top: 10px;
    }
  }

  @media (max-width: 900px) {
    .dashboard-header {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-left: 1rem !important;
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
    .dashboard-body {
      .nav-tabs {
        paddding: 20px;
        margin-left: -1px;
        background-color: white !important;
      }
    }
  }

  .hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
  }
  .hr-text:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 3.5px;
  }
  .hr-text:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;
    padding: 0 0.5em;
    line-height: 1.5em;
    background-color: white;
    font-weight: 400;
  }

  .hr-green:after {
    color: #4e9e69;
  }

  .hr-blue:after {
    color: ${colors.blueDark};
  }

  .hr-green:before {
    background: #4e9e69; //linear-gradient(to right, transparent, #4E9E69, transparent);
  }

  .hr-blue:before { 
    background: ${colors.blueDark}; //linear-gradient(to right, transparent, #4E9E69, transparent);
  }
  }

  div._2iwr {
    height: 40px;
    left: 40px;
    right: auto;
    top: 0;
    width: 8px;
  }

  div._2iws {
    height: 8px;
    left: 48px;
    top: 0;
  }

  div._2iwt {
    left: 25%;
    top: 8px;
  }

  div._2iwu {
    height: 12px;
    left: 48px;
    top: 14px;
  }

  div._2iwv {
    left: 20%;
    top: 26px;
  }

  div._2iww {
    height: 10px;
    left: 48px;
    top: 32px;
  }

  div._2iwx {
    height: 20px;
    top: 40px;
  }

  div._2iwy {
    left: 75%;
    top: 60px;
  }

  div._2iwz {
    height: 13px;
    top: 66px;
  }

  div._2iw- {
    left: 100%;
    top: 79px;
  }

  div._2iw_ {
    height: 13px;
    top: 85px;
  }

  div._2ix0 {
    left: 30%;
    top: 98px;
  }

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  .complete-guide-btns {
    display: flex;
    justify-content: center;
  }
`
